import React from 'react'
import createServerMutation from 'graphs/mutations/createServer.graphql'
import serverValidation from 'validations/server'
import FormForRecord from 'components/FormForRecord'
import serverFields from 'fields/servers'

const RouteProductServersNew = ({ history: { goBack }, product, ...rest }) => (
  <FormForRecord
    mutation={createServerMutation}
    onSuccess={goBack}
    onCancel={goBack}
    fields={serverFields}
    variables={{ data: { product_id: product.id } }}
    schema={serverValidation}
    title={`Create A Server for ${product.name}`}
    {...rest}
  />
)

export default RouteProductServersNew



// WEBPACK FOOTER //
// ./src/routes/admin/products/servers/new.js